import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconRuler = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-ruler_svg__a)"
      d="M16 4.563c0 .25-.125.5-.313.687L5.22 15.719A.97.97 0 0 1 4.53 16a.99.99 0 0 1-.718-.281L.28 12.188a.99.99 0 0 1-.281-.72c0-.25.094-.5.281-.687L1.97 9.062l1.781 1.782a.502.502 0 0 0 .344.156c.281 0 .5-.25.5-.5a.577.577 0 0 0-.157-.375l-1.75-1.75 1.407-1.406 1.781 1.75a.502.502 0 0 0 .344.156c.281 0 .5-.219.5-.5 0-.125-.063-.25-.157-.375l-1.75-1.75L6.22 4.844 8 6.594a.502.502 0 0 0 .344.156c.281 0 .5-.219.5-.5a.502.502 0 0 0-.156-.344l-1.75-1.781 1.406-1.406 1.75 1.75c.094.093.25.156.375.156.281 0 .5-.219.5-.5a.502.502 0 0 0-.156-.344L9.03 2 10.75.312c.188-.187.438-.312.688-.312.28 0 .53.125.718.313l3.531 3.53c.188.188.313.438.313.72Z"
    />
    <defs>
      <linearGradient
        id="icon-ruler_svg__a"
        x1={16}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconRuler;
